import { ExtendedArchetype } from "@/models/sharedModels";
import styles from "./Cartesian.module.css";
//s

export default function Cartesian(props: ExtendedArchetype) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2>Archetype Breakdown</h2>
      </div>
      <div className={styles.main}>
        <p className={styles.label}>Influence</p>
        <div className={styles.parent}>
          <div className={styles.rowTop}>
            <div
              style={
                props.acronym === "ID"
                  ? {
                      background: `linear-gradient(to top right,transparent 50%,grey 50%)`,
                    }
                  : props.acronym === "DI"
                  ? {
                      background: `linear-gradient(to bottom left,transparent 50%,grey 50%)`,
                    }
                  : {}
              }
              className={styles.leftTop}
            >
              <p className={styles.label}>Dominant</p>
            </div>
            <div
              style={
                props.acronym === "IS"
                  ? {
                      background: `linear-gradient(to top left,transparent 50%,grey 50%)`,
                    }
                  : props.acronym === "SI"
                  ? {
                      background: `linear-gradient(to bottom right,transparent 50%,grey 50%)`,
                    }
                  : {}
              }
              className={styles.RightTop}
            >
              <p className={styles.label}>Supportive</p>
            </div>
          </div>
          <div className={styles.row}>
            <div
              style={
                props.acronym === "DC"
                  ? {
                      background: `linear-gradient(to top left,transparent 50%,grey 50%)`,
                    }
                  : props.acronym === "CD"
                  ? {
                      background: `linear-gradient(to bottom right,transparent 50%,grey 50%)`,
                    }
                  : {}
              }
              className={styles.leftBottom}
            ></div>
            <div
              style={
                props.acronym === "SC"
                  ? {
                      background: `linear-gradient(to top right,transparent 50%,grey 50%)`,
                    }
                  : props.acronym === "CS"
                  ? {
                      background: `linear-gradient(to bottom left,transparent 50%,grey 50%)`,
                    }
                  : {}
              }
              className={styles.rightBottom}
            ></div>
          </div>
          <div className={styles.lineTopLeft}></div>
          <div className={styles.lineTopRight}></div>
          <div className={styles.lineBottomLeft}></div>
          <div className={styles.lineBottomRight}></div>
          <p className={styles.di}>(DI)</p>
          <p className={styles.id}>(ID)</p>
          <p className={styles.is}>(IS)</p>
          <p className={styles.si}>(SI)</p>
          <p className={styles.sc}>(SC)</p>
          <p className={styles.cs}>(CS)</p>
          <p className={styles.cd}>(CD)</p>
          <p className={styles.dc}>(DC)</p>
        </div>
        <p className={styles.label}>Cautious</p>
      </div>
    </div>
  );
}
